import {
    FETCH_SOCIAL_GROUP_RIDE,
    FETCH_SOCIAL_GROUP_RIDE_SUCCESS,
    FETCH_SOCIAL_GROUP_RIDE_FAIL,
    FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS_SUCCESS,
    DISMISS_SOCIAL_GROUP_RIDE_DATA_DELETE_SUCCESS,
    DELETE_SOCIAL_GROUP_RIDE_USER_DATA_SUCCESS
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    socialGroupRide: null,
    groupRideFetching: false,
    socialGroupRideCompetitions: null,
    groupRideDataDeletedNow: false // used to trigger the Snackbar/Notification when the user clicks 'Remove Me'
};

const requestSocialGroupRide = (state) => {
    return {
        ...state,
        groupRideFetching: true
    };
};

const fetchSocialGroupRideSuccess = (state, action) => ({
    ...state,
    socialGroupRide: action.groupRide,
    groupRideFetching: false
});

const fetchSocialGroupRideCompetitionsSuccess = (state, action) => ({
    ...state,
    socialGroupRideCompetitions: action.socialGroupRideCompetitions
});

const fetchSocialGroupRideFail = (state) => ({
    groupRideFetching: false,
    groupRideDataDeletedNow: state.groupRideDataDeletedNow
});

const setSocialGroupRideDataDeletedNow = (state) => ({
    ...state,
    groupRideDataDeletedNow: true
});

const dismissSocialGroupRideDataDeleteSuccess = (state) => ({
    ...state,
    groupRideDataDeletedNow: false
});

const handlers = {
    [FETCH_SOCIAL_GROUP_RIDE]: requestSocialGroupRide,
    [FETCH_SOCIAL_GROUP_RIDE_SUCCESS]: fetchSocialGroupRideSuccess,
    [FETCH_SOCIAL_GROUP_RIDE_FAIL]: fetchSocialGroupRideFail,
    [FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS_SUCCESS]: fetchSocialGroupRideCompetitionsSuccess,
    [DELETE_SOCIAL_GROUP_RIDE_USER_DATA_SUCCESS]: setSocialGroupRideDataDeletedNow,
    [DISMISS_SOCIAL_GROUP_RIDE_DATA_DELETE_SUCCESS]: dismissSocialGroupRideDataDeleteSuccess
};

export default function groupRide(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export const getSocialGroupRideFetching = (state) => state.groupRide.groupRideFetching;
export const getSocialGroupRide = (state) => state.groupRide.socialGroupRide;
export const getSocialGroupRideCompetitions = (state) => state.groupRide.socialGroupRideCompetitions;
export const getSocialGroupRideDataDeletedNow = (state) => state.groupRide.groupRideDataDeletedNow;
